import React, { Fragment, useState, useContext, useEffect } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Navigate } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@mui/styles";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  List,
  Search,
  Link,
  Close,
  CheckCircleOutlineOutlined,
} from "@mui/icons-material";
import { DataGrid, GridActionsCellItem, gridClasses } from "@mui/x-data-grid";
import axios from "axios";
import clsx from "clsx";
import {
  Grid,
  Tooltip,
  Box,
  Alert,
  Card,
  TextField,
  Snackbar,
  ClickAwayListener,
  Typography,
} from "@mui/material";
import { Calendar } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { format, addDays } from "date-fns";
import { es } from "date-fns/locale";
import Moment from "moment";
import { CopyToClipboard } from "react-copy-to-clipboard";

import NewLinkPaymentsAdmin from "views/Dialog/NewLinkPaymentsAdmin";
import ViewsTrasactionsPayment from "views/Dialog/ViewsTrasactionsPayment";
import StatusPaymentLinkAdmin from "views/Dialog/StatusPaymentLinkAdmin";
import ViewLinkAdmin from "views/Dialog/ViewLinkAdmin";

import loaderGif from "assets/img/loading.gif";

import {
  cardBodyStyle,
  ButtonTableGrid2,
  ButtonTableGrid1,
  blackColor,
} from "components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

// Crea un tema personalizado
const theme = createTheme({
  components: {
    MuiTablePagination: {
      styleOverrides: {
        displayedRows: {
          color: "black", // Cambia el color del texto a negro
        },
      },
    },
  },
});

export default function WalletClients() {
  const classes = useStyles();

  const [idRow, setIdRow] = useState("");
  const [openStatus, setOpenStatus] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [rows, setRows] = useState([]);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(false);
  const [totalOutstandingBalance, setTotalOutstandingBalance] =
    useState("0.00");
  const [mensageSystem, setMensageSystem] = useState("");
  const [openSnackbar, setOpenSnackbar] = React.useState({
    mensage: "",
    open: false,
  });
  const [showStartCalendar, setShowStartCalendar] = useState(false);
  const [openDetails, setOpenDetails] = React.useState(false);
  const [openNew, setOpenNew] = useState(false);
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [searchText, setSearchText] = useState("");
  const [rowsResponse, setRowsResponse] = useState([]);
  const [dateStart, setDateStart] = useState(false);
  const [dateEnd, setDateEnd] = useState(false);
  const [showEndCalendar, setShowEndCalendar] = useState(false);

  let resultSearch = "";

  const { urlServices, UserAuth, urlWeb } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [values, setValues] = useState({
    endLink: null,
    startLink: null,
  });

  const [state] = useState({
    columns: [
      {
        headerName: "Ref.",
        field: "reference",
        headerAlign: "center",
        width: 70,
        align: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return (
            <>
              <span
                style={{ fontSize: 12, color: blackColor }}
              >{`${params.row.reference}`}</span>
            </>
          );
        },
      },
      {
        headerName: "Cliente",
        field: "name",
        // headerAlign: "center",
        //  width: 300,
        flex: 1,
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return (
            <>
              <Box
                sx={{ fontSize: 14, my: 3 }}
              >{`${params.row.name} ${params.row.lastName}`}</Box>
            </>
          );
        },
      },
      /*{
        headerName: "Documento",
        field: "documentId",
        headerAlign: "center",
        width: 130,
        align: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return (
            <>
              <span style={{ fontSize: 14 }}>{`${params.row.documentId}`}</span>
            </>
          );
        },
      },
      {
        headerName: "Correo electrónico",
        field: "email",
        headerAlign: "center",
        width: 240,
        //align: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return (
            <>
              <span style={{ fontSize: 14 }}>{`${params.row.email}`}</span>
            </>
          );
        },
      },*/
      {
        headerName: "Descripción",
        field: "description",
        headerAlign: "center",
        width: 250,
        // align: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return (
            <>
              <span
                style={{ fontSize: 14 }}
              >{`${params.row.description}`}</span>
            </>
          );
        },
      },
      {
        headerName: "Fee",
        field: "commissionPayment",
        headerAlign: "center",
        width: 90,
        align: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return (
            <>
              <span
                style={{ fontSize: 14, color: "red" }}
              >{`$${params.row.commissionPayment}`}</span>
            </>
          );
        },
      },
      {
        headerName: "Total",
        field: "total",
        headerAlign: "center",
        width: 90,
        align: "center",
        headerClassName: "super-app-theme--header",
        renderCell: (params) => {
          return (
            <>
              <span
                style={{ fontSize: 14 }}
              >{`$${params.row.commissionPaymentTotal}`}</span>
            </>
          );
        },
      },
      {
        headerName: "---",
        field: "slug",
        headerClassName: "super-app-theme--header",
        width: 140,
        headerAlign: "center",
        renderCell: (params) => {
          return (<ButtonTableGrid1
                  onClick={handleDetails(params)}
                  style={{ margin: "4px 0", fontSize: 10, width: "100%", padding: "6px 1px" }}
                >
                  Transacción link de pago del cliente
                </ButtonTableGrid1>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "---",
        field: "id",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <CheckCircleOutlineOutlined
              sx={{ color: "#2e7d32", fontSize: 26 }}
            />
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 25,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Transferencia",
        field: "adminPaymentDate",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <span>
              {params.value ? Moment(params.value).format("DD-MM-YYYY") : ""}{" "}
            </span>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 120,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "-----",
        field: "actions",
        type: "actions",
        width: 60,
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celActions: params.value,
          });
        },
        getActions: (params) => {
          const actions = [];

          actions.push(
            <GridActionsCellItem
              key="disable"
              icon={
                <Tooltip title="Ver registro" arrow>
                  <Search style={{ fontSize: 24, color: "#000" }} />
                </Tooltip>
              }
              label="Ver registro"
              onClick={openViewValue(params)}
            />
          );
          return actions;
        },
      },
    ],
  });

  // Función para eliminar acentos de una cadena de texto
  const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const handleCopy = () => {
    setOpenSnackbar({ mensage: "Link copiado al portapapeles!", open: true });
  };

  const handleSearchChange = (event) => {
    const searchValue = event.target.value;
    setSearchText(searchValue);

    if (searchValue.trim() !== "") {
      const searchLower = removeAccents(searchValue.toLowerCase());

      resultSearch = rows.filter((item) => {
        // Búsqueda por nombre de proveedor
        const nameMatch = removeAccents(item.name.toLowerCase() || "").includes(
          searchLower
        );

        // Búsqueda por nombre de aplicación
        const lastNameMatch = item.lastname
          ?.toLowerCase()
          .includes(searchLower);

        const descriptionMatch = item.description
          ?.toLowerCase()
          .includes(searchLower);
        // Búsqueda por ID (convertimos ambos a string para comparar)
        // const idMatch = item.talamoChinaconexionRequestsId
        const referenceMatch = item.reference?.toString().includes(searchValue);

        return nameMatch || lastNameMatch || descriptionMatch || referenceMatch;
      });

      setRows(resultSearch);
    } else {
      setRows(rowsResponse);
    }
  };

  const RefreshTable = (filterValues = values) => {
    axios
      .get(
        `${urlServices}payment-link/list-client-payment-admin/${UserAuth.clients_id}`,
        {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          let filteredData = response.data;

          // Usa filterValues en lugar de values
          if (filterValues.startLink && filterValues.endLink) {
            const fromDate = Moment(filterValues.startLink).format(
              "YYYY-MM-DD"
            );
            const toDate = Moment(filterValues.endLink).format("YYYY-MM-DD");

            filteredData = filteredData.filter((client) => {
              const clientDate = Moment(client.adminPaymentDate).format(
                "YYYY-MM-DD"
              );
              return clientDate >= fromDate && clientDate <= toDate;
            });
          }

          let totalPendingValue = 0;

          let dataFinal = filteredData.map((data) => {
            const commissionPercentage = parseFloat(
              data.client?.percentage || 0
            );
            const payTotal = parseFloat(data.total || 0);

            // Cálculo de la comisión
            const commission = (commissionPercentage * payTotal) / 100;

            // Cálculo del total a transferir (total - comisión)
            const transferAmount = payTotal - commission;

            totalPendingValue += transferAmount;
            return {
              ...data,
              commissionPayment: commission.toFixed(2),
              commissionPaymentTotal: transferAmount.toFixed(2),
            };
          });

          const now = Moment(); // Fecha actual
          const sevenDaysAgo = Moment().subtract(7, "days"); // Fecha hace 7 días

          const OutstandingBalance = dataFinal.filter((data) => {
            const paymentDate = Moment(data.adminPaymentDate);

            // Verificar si la fecha de pago está entre hace 7 días y ahora
            return paymentDate.isBetween(sevenDaysAgo, now, undefined, "[]");
            // El '[]' incluye los límites (hace exactamente 7 días y la fecha actual)
          });
          // Sumar todos los montos de las transacciones pasada de 2 dias
          const totalOutstandingBalanceValue = OutstandingBalance.reduce(
            (sum, transaction) => {
              // Asegúrate de que transaction.amount es un número (por si acaso)
              const amount = Number(transaction.commissionPaymentTotal) || 0;
              return sum + amount;
            },
            0
          );

          setTotalOutstandingBalance(totalOutstandingBalanceValue);
          setRows(dataFinal);
          setRowsResponse(dataFinal);
          setLoader(false);
        }
      })
      .catch((e) => {
        if (e.response.status === 401) {
          setMensageSystem(
            "La sesión ha expirado, vuelva a iniciar sesión ..."
          );
          setError(true);

          setTimeout(() => {
            localStorage.clear();
            setReturnLogin(true);
          }, 4000);
        } else if (e.response.status === 500) {
          setRows([]);
          setMensageSystem("Error en la consulta con sel servidor.");
          setError(true);
        }
      });
  };

  // Agrega este efecto
  useEffect(() => {
    RefreshTable();
  }, [values.startLink, values.endLink]); // Se ejecutará cuando cambien las fechas

  // Manejar cambio de fecha inicial
  const handleDateStartChange = (date) => {
    setDateStart(date);
    const formattedDate = format(date, "yyyy/MM/dd");

    if (dateEnd && dateEnd <= date) {
      setDateEnd(null);
      setValues((prev) => ({ ...prev, endLink: "" }));
    }

    setValues((prev) => ({
      ...prev,
      startLink: formattedDate,
    }));
    setShowStartCalendar(false);
  };

  // Manejar cambio de fecha final
  const handleDateEndChange = (date) => {
    setDateEnd(date);
    const formattedDate = format(date, "yyyy/MM/dd");

    setValues((prev) => ({
      ...prev,
      endLink: formattedDate,
    }));
    setShowEndCalendar(false);
  };

  const changeClientsDeleteFilter = () => {
    // 1. Primero limpia los valores
    const newValues = {
      ...values,
      startLink: null,
      endLink: null,
    };

    setValues(newValues);
    setDateStart(false);
    setDateEnd(false);

    // 2. Luego refresca la tabla con los nuevos valores
    RefreshTable(newValues); // Pasa los nuevos valores explícitamente
  };

  const openStatusValue = (data, status) => () => {
    setIdRow({ id: data.row.id, status: status });
    setOpenStatus(true);
  };

  const openViewValue = (data) => () => {
    setIdRow(data.row);
    setOpenView(true);
  };

  const handleCloseNew = () => setOpenNew(false);
  const handleCloseStatus = () => setOpenStatus(false);
  const handleCloseView = () => setOpenView(false);

  const handleCloseSnackbar = () => {
    setOpenSnackbar({ open: false });
  };

  const handleDetails = (data) => () => {
    setIdRow(data.row);
    setOpenDetails(true);
  };

  const handleCloseDetails = () => {
    setOpenDetails(false);
  };

  if (returnLogin) {
    return <Navigate to="/" />;
  }

  return (
    <Grid container>
      <Grid xs={12} sm={12} md={12}>
        <Card
          sx={{ padding: "15px 20px", margin: { xs: "60px 0", sm: "10px 0" } }}
          variant="outlined"
        >
          {error ? <Alert severity="error">{mensageSystem}</Alert> : ""}
          {loader ? (
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <center>
                  <img
                    alt="loaderGif"
                    src={loaderGif}
                    style={{ width: 60, margin: "20% 0" }}
                  />
                </center>
              </Grid>
            </Grid>
          ) : (
            <Fragment>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={9} sx={{ mt: 2}}>
                  <div className={classes.cardTitleBlack}>
                    <List className={classes.iconFilter} /> Mi billetera
                    <Alert severity="info" sx={{ width: 450, mt: 1 }}>
                      Pagos realizados por la administración <b>BooknPay</b>.
                    </Alert>
                  </div>
                </Grid>
                <Grid item xs={12} sm={3} sx={{ mb: 1 }}>
                  {values.startLink && values.endLink ? (
                    <Typography
                      sx={{
                        color: "text.secondary",
                        mb: 1,
                        fontWeight: "bold",
                        fontSize: 18,
                      }}
                    >
                      Pagos realizados
                    </Typography>
                  ) : (
                    <>
                      <Typography
                        sx={{
                          color: "text.secondary",
                          mb: 1,
                          fontWeight: "bold",
                          fontSize: 18,
                        }}
                      >
                        Últimos pagos <br></br>
                        <Box style={{ fontSize: 12, top: "-8px" }}>
                          (Transferencias de la última semana)
                        </Box>
                      </Typography>
                    </>
                  )}
                  <Box
                    sx={{
                      fontSize: 26,
                      fontWeight: "bold",
                      borderRadius: 2,
                      p: "10px 15px",
                      background:
                        "linear-gradient(145deg, rgb(237, 247, 237), rgb(30, 70, 32, 0.1))",
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.05)",
                      width: "100%",
                      textAlign: "center",
                      // maxWidth: 200,
                      // margin: '0 auto',
                      //  border: '1px solid',
                      // borderColor: 'divider',
                      color: "rgb(30, 70, 32)",
                      "&:hover": {
                        boxShadow: "0 6px 12px rgba(0, 0, 0, 0.1)",
                      },
                    }}
                  >
                    {parseFloat(totalOutstandingBalance).toFixed(2)}
                    <span
                      style={{
                        fontWeight: "500",
                        fontSize: 12,
                        marginLeft: 10,
                      }}
                    >
                      USD
                    </span>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <div
                    className={classes.cardTitleBlack}
                    style={{ fontSize: 14 }}
                  >
                    Filtro por fecha:
                  </div>
                </Grid>
                <Grid item xs={12} md={3}>
                  <ClickAwayListener
                    onClickAway={() => setShowStartCalendar(false)}
                  >
                    <Box sx={{ position: "relative" }}>
                      <TextField
                        fullWidth
                        label="Fecha inicial"
                        value={dateStart ? format(dateStart, "dd/MM/yyyy") : ""}
                        onClick={() => setShowStartCalendar(!showStartCalendar)}
                        InputProps={{
                          readOnly: true,
                        }}
                        size="small"
                      />
                      {showStartCalendar && (
                        <Box
                          sx={{
                            position: "absolute",
                            zIndex: 1300,
                            mt: 1,
                            "& .rdrCalendarWrapper": {
                              borderRadius: "8px",
                              boxShadow: 3,
                              width: "100%",
                            },
                          }}
                        >
                          <Calendar
                            date={dateStart}
                            onChange={handleDateStartChange}
                            locale={es}
                            color={blackColor}
                          />
                        </Box>
                      )}
                    </Box>
                  </ClickAwayListener>
                </Grid>

                <Grid item xs={12} md={3}>
                  <ClickAwayListener
                    onClickAway={() => setShowEndCalendar(false)}
                  >
                    <Box sx={{ position: "relative" }}>
                      <TextField
                        fullWidth
                        label="Fecha final"
                        value={dateEnd ? format(dateEnd, "dd/MM/yyyy") : ""}
                        onClick={() => setShowEndCalendar(!showEndCalendar)}
                        InputProps={{
                          readOnly: true,
                        }}
                        disabled={!dateStart}
                        size="small"
                      />
                      {showEndCalendar && (
                        <Box
                          sx={{
                            position: "absolute",
                            zIndex: 1300,
                            mt: 1,
                            "& .rdrCalendarWrapper": {
                              borderRadius: "8px",
                              boxShadow: 3,
                              width: "100%",
                            },
                          }}
                        >
                          <Calendar
                            date={dateEnd}
                            onChange={handleDateEndChange}
                            locale={es}
                            color={blackColor}
                            minDate={
                              dateStart ? addDays(dateStart, 1) : undefined
                            }
                          />
                        </Box>
                      )}
                    </Box>
                  </ClickAwayListener>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <b
                    style={{
                      fontSize: 10,
                      color: "red",
                      cursor: "pointer",
                      display: dateStart && dateEnd ? "block" : "none",
                      marginTop: 15,
                    }}
                    onClick={changeClientsDeleteFilter}
                  >
                    <Close sx={{ fontSize: 18 }} /> ELIMINAR FILTRO
                  </b>
                </Grid>
                <Grid item xs={12} sm={3}>
                  {/* Campo de búsqueda */}
                  <TextField
                    variant="outlined"
                    value={searchText}
                    onChange={handleSearchChange}
                    sx={{ marginBottom: 2, width: "100%" }}
                    size="small"
                    InputProps={{
                      startAdornment: (
                        <Search
                          position="start"
                          style={{
                            color: "gray",
                            fontSize: 22,
                            marginRight: 10,
                          }}
                        />
                      ),
                    }}
                    placeholder="Buscar"
                    autoComplete="off"
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box
                    sx={{
                      "& .super-app.celAll": {
                        fontSize: 12,
                        //backgroundColor: 'rgba(255, 7, 0, 0.55)',
                      },
                      "& .super-app.celActions": {
                        backgroundColor: "rgb(242, 242, 242)",
                      },
                      "& .super-app-theme--header": {
                        backgroundColor: "rgb(242, 242, 242)",
                      },
                      marginTop: 2,
                    }}
                  >
                    <ThemeProvider theme={theme}>
                      <DataGrid
                        rows={rows}
                        columns={state.columns}
                        loading={loader}
                        initialState={{
                          pagination: {
                            paginationModel: { page: 0, pageSize: 10 },
                          },
                        }}
                        pageSizeOptions={[5, 10, 20, 50]}
                        disableRowSelectionOnClick={true}
                        checkboxSelection={false}
                        rowHeight={140}
                        sx={{
                          [`& .${gridClasses.cell}`]: {
                            display: "flex",
                            alignItems: "center", // Alineación vertical
                            // justifyContent: 'center', // Alineación horizontal
                            //wordWrap: 'break-word !important',
                            //whiteSpace: 'normal !important',
                          },
                          /* [`& .${gridClasses.columnHeaderTitle}`]: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          },*/
                        }}
                        getRowHeight={() => "auto"}
                        //autoHeights
                        autoWidth
                      />
                    </ThemeProvider>
                  </Box>
                </Grid>
              </Grid>
            </Fragment>
          )}
        </Card>
      </Grid>
      <Snackbar
        open={openSnackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="success"
          variant="filled"
        >
          {openSnackbar.mensage}
        </Alert>
      </Snackbar>
      {openNew && (
        <NewLinkPaymentsAdmin
          open={openNew}
          exit={handleCloseNew}
          callBackRefresh={RefreshTable}
        />
      )}
      {openView && (
        <ViewLinkAdmin open={openView} exit={handleCloseView} id={idRow} />
      )}
      {openDetails && (
        <ViewsTrasactionsPayment
          open={openDetails}
          exit={handleCloseDetails}
          id={idRow}
        />
      )}
      {openStatus && (
        <StatusPaymentLinkAdmin
          open={openStatus}
          exit={handleCloseStatus}
          id={idRow}
          callBackRefresh={RefreshTable}
        />
      )}
    </Grid>
  );
}
